import type { Plan } from '@rundown-studio/types'

import { atom } from 'jotai'
import { columnCountAtom, cuesAtom } from './rundown.store'

//
// Payment plan
//
export const planAtom = atom<Plan | null>(null)

export const getIsCuesLimitExceededAtom = atom(
  null,
  (get, _set, cueCountToAdd: number) => {
    const plan = get(planAtom)
    const cues = get(cuesAtom)

    if (!plan) return false

    const cuesCount = Object.entries(cues).length

    return (
      plan.limits.cues !== -1 && plan.limits.cues < cuesCount + cueCountToAdd
    )
  },
)

export const isColumnsLimitExceededAtom = atom((get) => {
  const plan = get(planAtom)

  if (!plan) return false

  const columnsCount = get(columnCountAtom)

  return plan.limits.columns !== -1 && plan.limits.columns <= columnsCount
})
